// components/About.js (actualizado)
import React from 'react';
import ScrollAnimation from './ScrollAnimation';
import Team from './Team'; // Nuevo componente

const About = () => {
    return (
        <section id="quienes-somos" className="py-16 bg-white">
            <div className="container mx-auto px-6">
                <ScrollAnimation>
                    <h2 className="text-3xl font-bold font-poppins text-grafito mb-8 text-center">Quiénes somos</h2>
                </ScrollAnimation>
                <div className="max-w-4xl mx-auto">
                    <ScrollAnimation delay={0.2}>
                        <p className="text-lg text-grafito font-lato mb-6">
                            Somos Iron Five, una empresa conformada por cinco hermanos profesionales de las ciencias sociales, el derecho y la ingeniería en sistemas.
                        </p>
                    </ScrollAnimation>
                    <ScrollAnimation delay={0.4}>
                        <p className="text-lg text-grafito font-lato mb-12">
                            Nuestra experiencia en la gestión pública nos permite comprender a fondo las dinámicas, necesidades y desafíos de las instituciones estatales, y transformarlas en soluciones tecnológicas innovadoras.
                        </p>
                    </ScrollAnimation>
                </div>

                {/* Sección del equipo */}
                <Team />
            </div>
        </section>
    );
};

export default About;
